import { gql } from "apollo-boost";

import useMutation, { mutationTypes } from "@utils/graphqlUtils";

const MUTATION = gql`
  mutation(
    $data: VisitReportCreateInput!
  ) {
    createOneVisitReport(data: $data) {
      id
    }
  }
`;

export default () => (
  useMutation(MUTATION, `Relatório de visita criado`, mutationTypes.CREATE)
);
